import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import Slider from "react-slick";

import HomeUrl from '../assets/images/home-border.png';
import Img1 from '../assets/images/users/img-1.png';
import Img2 from '../assets/images/users/img-2.png';
import Img3 from '../assets/images/users/img-3.png';
import Img4 from '../assets/images/users/img-4.png';

export default class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      teams: [
        {
          id: 1,
          img: Img1,
          name: 'Ava Johnson',
          nickname: '#ProjectManager',
          description: 'Ava oversees project execution, ensuring timely delivery and client satisfaction in every phase.'
        },
        {
          id: 2,
          img: Img2,
          name: 'Liam Thompson',
          nickname: '#LeadDeveloper',
          description: 'Liam leads development, crafting efficient solutions tailored to each client’s digital needs.'
        },
        {
          id: 3,
          img: Img3,
          name: 'Sophia Martinez',
          nickname: '#MarketingStrategist',
          description: 'Sophia drives Webora’s marketing efforts, developing data-driven strategies for optimal impact.'
        },
        {
          id: 4,
          img: Img4,
          name: 'Ethan Brown',
          nickname: '#UIUXDesigner',
          description: 'Ethan focuses on creating intuitive and visually compelling designs that enhance user experience.'
        },
      ],
    };
  }

  render() {
    var temsettings = {
      autoplay: true,
      dots: true,
      speed: 300,
      infinite: false,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 1,
    };

    return (
      <React.Fragment>
        <section className="section bg-light bg-cta">
          <Container>
            <Row className="justify-content-center">
              <Col lg={9}>
                <div className="text-center">
                  <h2>Get Started With <span className="text-primary">Webora</span></h2>
                  <p className="text-muted mt-3">
                    Ready to elevate your business with top-notch IT and digital marketing solutions? Webora combines technology and strategy to deliver measurable results for every client.
                  </p>
                  <p className="text-muted">
                    From custom websites to comprehensive digital campaigns, we’re here to bring your vision to life.
                  </p>
                  <div className="mt-4 pt-2">
                     <Link to="#" className="btn btn-primary btn-round btn-rounded">Contact Us</Link>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        
      </React.Fragment>
    );
  }
}
